import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderBannerOffer = (data) => openPopupHelper({ popupName: popupNames.BANNER_OFFER, data });
